import api from 'api'
import { EQUIPMENT_LIST } from '../constants/endpointKeys'
import { type IEquipmentListResponse, type IEquipmentListParams } from './types'

export const equipmentList = async (params: IEquipmentListParams) => {
  return await api
    .get<IEquipmentListResponse>(EQUIPMENT_LIST, { params })
    .then(({ data }) => data.produtos)
}
